import React from 'react'

export default ({ staff, onClick, isSelected }) => (
  <div
    onClick={onClick}
    className={`px-4 py-3 cursor-pointer border-b border-gray-200 transition-colors duration-150 ${
      isSelected
        ? 'bg-primary text-white font-semibold'
        : 'bg-white hover:bg-gray-50 text-gray-900'
    }`}
  >
    {staff.firstName} {staff.lastName}
  </div>
)
